let formWorkValidator = null;
let lang;
const formWorkInitValidator = function() {
    if (formWorkValidator == null) {
        if ($('#form-work').length) {
            lang = 'EN';
        } else if ($('#form-work-es').length) {
            lang = 'ES';
        }
        if ('EN' == lang) {
            formWorkValidator = $('#form-work').validate({
                rules: {
                    work_name: {
                        required: true
                    },
                    work_email: {
                        required: true,
                        email: true
                    },
                    work_cv: {
                        required: true
                    },
                    work_comments: {
                        required: true
                    }
                },
                messages: {
                    work_name: {
                        required: 'Write your name, please'
                    },
                    work_email: {
                        required: 'Write your email, please',
                        email: 'The email is not correct'
                    },
                    work_cv: {
                        required: 'Attach your CV, please'
                    },
                    work_comments: {
                        required: 'Write your comments, please'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        } else if ('ES' == lang) {
            formWorkValidator = $('#form-work-es').validate({
                rules: {
                    work_name: {
                        required: true
                    },
                    work_email: {
                        required: true,
                        email: true
                    },
                    work_cv: {
                        required: true
                    },
                    work_comments: {
                        required: true
                    }
                },
                messages: {
                    work_name: {
                        required: 'Escriba su nombre, por favor'
                    },
                    work_email: {
                        required: 'Escriba su email, por favor',
                        email: 'El email no es correcto'
                    },
                    work_cv: {
                        required: 'Adjunte su CV, por favor'
                    },
                    work_comments: {
                        required: 'Escriba sus comentarios, por favor'
                    }
                },
                errorElement: 'span',
                errorClass: 'error',
                errorPlacement: function (error, element) {
                    error.insertAfter(element);
                },
                success: function (label, element) {
                    if ($(element).next('span')[0])
                        $(element).next('span')[0].remove();
                },
                highlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').addClass('alert').addClass('alert-danger');
                },
                unhighlight: function (element, errorClass, validClass) {
                    $(element).closest('.form-group').removeClass('alert').removeClass('alert-danger');
                }
            });
        }
    }
}; 
const formWorkSend = function() {
    $('#work-success').addClass('d-none');
    $('#work-error').addClass('d-none');
    formWorkInitValidator();
    let url;
    if ('EN' == lang) {
        if (!$('#form-work').valid()) {
            return false;
        }
        url = '/api/formulario/workwithus';
    } else if ('ES' == lang) {
        if (!$('#form-work-es').valid()) {
            return false;
        }
        url = '/api/formulario/es/workwithus';
    }
    $('#btn-work-send').addClass('d-none');
    $('#btn-work-sending').removeClass('d-none');
    const payload = new FormData();
    payload.append('name', $('#work_name').val());
    payload.append('email', $('#work_email').val());
    payload.append('cv', $('#work_cv')[0].files[0]);
    payload.append('comments', $('#work_comments').val());
    payload.append('subject', 'Helicópteros Sanitarios: formulario "work with us"');
    $.ajax({
        type: 'POST',
        url: url,
        data: payload,
        processData: false,
        contentType: false,
        success: function (data, status, jqXHR) {
            $('#btn-work-send').removeClass('d-none');
            $('#btn-work-sending').addClass('d-none');
            if ('OK' == data.status) {
                $('#work_name,#work_nie,#work_nationality,#work_address,#work_email,#work_phone,#work_type').val('');
                //$('#work-success').html(data.message).removeClass('d-none');
                if ('EN' == lang) {
                    document.location.href = './thanks.html';
                } else if ('ES' == lang) {
                    document.location.href = './gracias.html';
                }
            } else {
                $('#work-error').html(data.message).removeClass('d-none');
            }
        },
        error: function (jqXHR, status) {
            $('#btn-work-send').removeClass('d-none');
            $('#btn-work-sending').addClass('d-none');
            if ('EN' == lang)
                $('#work-error').html('Your message has not been delivered, please try again.<br />If the problem persists please contact us at: info@helicopterossanitarios.com<br />Sorry for the inconvenience.').removeClass('d-none');
            else if ('ES' == lang)
                $('#work-error').html('Su mensaje no ha podido ser entregado, por favor inténtelo más tarde.<br />Si el problema persiste, póngase en contacto con nosotros en: info@helicopterossanitarios.com<br />Disculpe las molestias.').removeClass('d-none');
        }
    });
    return false;
};
  
window.formWorkSend = formWorkSend;